import { sendGAEvent } from 'utils/ga';
import { BOD_RULES } from 'utils/validations';

export const CONSTS = {
  POPOVER_POSITION: 'left',
  CTA_TAP: 'Tap',
  CTA_EDIT: 'Edit',
  DAY: {
    KEY: 'day',
    LABEL: 'Ngày',
    VALIDATE: {
      min: 1,
      max: 31,
      required: true,
    },
  },
  MONTH: {
    KEY: 'month',
    LABEL: 'Tháng',
    VALIDATE: {
      min: 1,
      max: 12,
      required: true,
    },
  },
  YEAR: {
    KEY: 'year',
    LABEL: 'Năm',
    VALIDATE: {
      min: new Date().getFullYear() - BOD_RULES.MIN_AGE,
      max: new Date().getFullYear() - BOD_RULES.MAX_AGE + 1,
    },
  },
  LBL_HEADER: 'Ngày tháng năm sinh',
  SEND_GA: async (actionName, fieldName) => {
    const transField = fieldName.toUpperCase();
    await sendGAEvent(
      `${actionName}_${transField}_Textbox`,
      `${transField}_Textbox`,
      'ACL_0BOD_Basic_Info',
    );
  },
};
